/**
 * @generated SignedSource<<f83d1991d0df7422585a868885ade3eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AllStudentsFilterInput = {
  anyDiagnosticRetakeAssigned?: boolean | null | undefined;
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  lastDiagnosticCompletedFrom?: any | null | undefined;
  lastDiagnosticCompletedTo?: any | null | undefined;
  onlyWithOutstandingDiagnostic?: boolean | null | undefined;
  onlyWithResetDiagnostic?: boolean | null | undefined;
  siteIds?: ReadonlyArray<string> | null | undefined;
  studentEmailContains?: string | null | undefined;
  studentEmails?: ReadonlyArray<string> | null | undefined;
  studentNameContains?: string | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type StudentsCountQuery$variables = {
  filter: AllStudentsFilterInput;
};
export type StudentsCountQuery$data = {
  readonly allStudents: {
    readonly totalCount: number;
  } | null | undefined;
};
export type StudentsCountQuery = {
  response: StudentsCountQuery$data;
  variables: StudentsCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      }
    ],
    "concreteType": "StudentConnection",
    "kind": "LinkedField",
    "name": "allStudents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentsCountQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StudentsCountQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5b0dacef40600e54b829f7a8059ca141",
    "id": null,
    "metadata": {},
    "name": "StudentsCountQuery",
    "operationKind": "query",
    "text": "query StudentsCountQuery(\n  $filter: AllStudentsFilterInput!\n) {\n  allStudents(filter: $filter, first: 1) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ac28d541dbc71e59c9653ab9a3fd9cd";

export default node;
